import React, { useEffect, useState } from "react";
import { Button, LinearProgress, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InformedConsent from "./informedConsent";
import PatientForm from "../patientForm/patientForm";
import { useNavigate } from "react-router-dom";
import ExitForm from "./exitForm";
import { steps } from "../../const.js";

const PatientScreening = ({formik, handleSubmit, handleSubmitReport, setAutoSubmitAfterInference, handleExitFormExit, handleExit, consent, setConsent, step, setStep, mlConsentGiven,setMlConsentGiven, imageUploadSessionKey = 0}) => {
    const [consentGiven, setConsentGiven] = useState(consent);
    // const [mlConsentGiven, setMlConsentGiven] = useState(mlConsentGivenParent)
    const [activeStep, setActiveStep] = useState(step);
    const [progress, setProgress] = useState(0);
    
    // CRITICAL FIX: Force consent=true when step > 0 (user can't be on step 1+ without consent)
    useEffect(() => {
        if (step > 0) {
            setConsentGiven(true);
        } else {
            setConsentGiven(consent);
        }
    }, [step, consent]);
    
    // Sync step when prop changes (e.g., when draft is loaded)
    useEffect(() => {
        setActiveStep(step);
    }, [step]);
    
    // CRITICAL: Create a wrapper function that updates both local and parent step state
    // This ensures the parent's step is saved to localStorage when user navigates
    const handleSetActiveStep = (newStep) => {
        setActiveStep(newStep);
        if (setStep && newStep !== step) {
            setStep(newStep);
        }
    };
    
    useEffect(() => {
        setProgress((activeStep + 1) * (100 / (steps.length + 1)));
    }, [activeStep]);
    const handleProceed = () => {
        setConsentGiven(true);
        // Update parent consent state so it gets saved to localStorage
        if (setConsent) {
            setConsent(true);
        }
    };
    
    const handleMlConsentConsentChange = (checked) => {
        setMlConsentGiven(checked);
        formik.setFieldValue("image_file.model_training_consent", checked);
    };

    useEffect(() => {
        // Disable scrolling when the popup is open
        if (!consentGiven) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        // Re-enable scrolling when the component unmounts
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [consentGiven]);
  return (
    <div>
        {consentGiven && <LinearProgress variant="determinate" value={progress} sx={{backgroundColor: "transparent"}} />}
        <div>
        <Stack direction="row" padding="10px 5%" justifyContent="end" alignItems="center" >
            {/* <Typography fontSize="28px" fontWeight="500" lineHeight="31px">
                Patient Screening
            </Typography> */}
            <Button
                className='exitButton'
                sx={{borderRadius: "8px", color: "#0D1E83", border: "1px solid #0D1E83", textTransform: "none"}}
                endIcon={<CloseIcon />}
                onClick={() => {handleExit()}}
            >
                Exit
            </Button>
        </Stack>
        </div>
        <div>
            {!consentGiven ?
                (
                    <div style={{position: "relative"}}>
                        <PatientForm
                            formik={formik}
                            steps={steps}
                            activeStep={activeStep}
                            setActiveStep={handleSetActiveStep}
                            imageUploadSessionKey={imageUploadSessionKey}
                        />
                        <div>
                        <InformedConsent handleProceed={handleProceed} handleExit={handleExitFormExit} handleMlConsentConsentChange={handleMlConsentConsentChange} mlConsentGiven={mlConsentGiven}/>
                        </div>
                    </div>
                )
                :
                (
                        <PatientForm
                            formik={formik}
                            steps={steps}
                            activeStep={activeStep}
                            setActiveStep={handleSetActiveStep}
                            handleSubmit={handleSubmit}
                            handleSubmitReport={handleSubmitReport}
                            setAutoSubmitAfterInference={setAutoSubmitAfterInference}
                            imageUploadSessionKey={imageUploadSessionKey}
                        />
                )
            }
        </div>
    </div>
  )
}

export default PatientScreening